<template>
  <div class="modal-card" style="width: auto;">
    <header class="modal-card-head">
      <span class="label has-text-primary">Report advertisement</span>
    </header>
    <section class="modal-card-body">
      <b-field label="Reason">
        <b-input type="textarea" v-model="reason" required
          placeholder="Describe why you report this advertisement" />
      </b-field>
    </section>

    <button class="button is-primary" @click="save">Apply</button>

  </div>
</template>

<script>
export default {
  data() {
    return {
      reason: null,
    };
  },
  methods: {
    save() {
      if (!this.reason) {
        this.$toast.open({
          message: 'Please add a reason',
          type: 'is-danger',
        });
        return;
      }
      this.$emit('reportSaved', { reason: this.reason });
      this.$parent.close();
    },
  },
};
</script>
